module.exports = __webpack_public_path__ + "static/media/chinese_text_analyze_demo.2a89e98f.mov";